import { render } from "./qrSvg.vue?vue&type=template&id=334cafac&scoped=true"
import script from "./qrSvg.vue?vue&type=script&lang=js"
export * from "./qrSvg.vue?vue&type=script&lang=js"

import "./qrSvg.vue?vue&type=style&index=0&id=334cafac&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sebastian\\Desktop\\-taptasty-order\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-334cafac"]])

export default __exports__